// Admin API client — /admin/errors-warnings/* (mirrors the API's errors-warnings aggregate).

import type { AdminServerLogEvent } from '@a7y/types';
import { client } from './transport';

export const errorsWarningsApi = {
  // Errors & Warnings
  getErrorsWarnings: (params?: {
    lookbackMinutes?: number;
    page?: number;
    limit?: number;
    sortBy?: string;
    sortOrder?: 'asc' | 'desc';
    event_type?: string;
    country_ip?: string;
    origin_host?: string;
  }) => {
    const searchParams = new URLSearchParams();
    if (params?.lookbackMinutes)
      searchParams.set('lookbackMinutes', String(params.lookbackMinutes));
    if (params?.page) searchParams.set('page', String(params.page));
    if (params?.limit) searchParams.set('limit', String(params.limit));
    if (params?.sortBy) searchParams.set('sortBy', params.sortBy);
    if (params?.sortOrder) searchParams.set('sortOrder', params.sortOrder);
    if (params?.event_type) searchParams.set('event_type', params.event_type);
    if (params?.country_ip) searchParams.set('country_ip', params.country_ip);
    if (params?.origin_host) searchParams.set('origin_host', params.origin_host);
    return client.get<{ data: AdminServerLogEvent[]; total: number; page: number; limit: number }>(
      `/errors-warnings?${searchParams}`
    );
  },
  getErrorWarningDetail: (messageId: string) =>
    client.get<AdminServerLogEvent>(`/errors-warnings/${messageId}`),
};
